/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProvisionDigitalWalletTokenRequest} from '@cash-web/protos/squareup/franklin/app/digital_wallet_token.pb'
import {ProvisionDigitalWalletTokenResponse} from '@cash-web/protos/squareup/franklin/app/digital_wallet_token.pb'


export const provisionDigitalWalletToken = (request: ProvisionDigitalWalletTokenRequest, options?: CashRequestOptions) => post<ProvisionDigitalWalletTokenRequest, ProvisionDigitalWalletTokenResponse>("/2.0/cash/provision-digital-wallet-token", request, {...options, rejectOnError: true })